








import {Component, Prop, Vue, Watch} from 'vue-property-decorator';

/**
 * @status experimental
 * @published $next
 * @changelog $next Published.
 */
@Component
export default class JdsAppFrame extends Vue {
    @Prop({type: Boolean, default: false}) loading!: boolean
    loadingProgress = 0

    get loadingBarStyles() {
        return {

        }
    }

    @Watch('loading')
    controlLoadingBar(state: boolean) {
        if (state) {

        } else {
            this.loadingProgress = 0
        }
    }
}
